<div class="card border-0 h-100 w-100">
  <div class="card-body">
    <div class="rep-label fw-semibold small mb-1 text-muted" *ngIf="!isAdditional">Primary Representative</div>
    <div class="rep-label" *ngIf="isAdditional">&nbsp;</div>
    <p class="fw-bold fs-5 text-dark mb-2">{{ name }}</p>

    <div class="d-flex align-items-center gap-1" style="font-size: x-small">
      <span class="material-symbols-outlined custom-card-title">mail</span>
      <a href="mailto:{{ email }}"
         class="fw-medium text-decoration-none">
        {{ email }}
      </a>
    </div>
  </div>
</div>
